import { FormControl, Grid, InputLabel, MenuItem, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { IFaixaSalarial } from '../../../../../commons/types/config';
import { useFaixaSalarialActions } from '../../../../../states/config/faixasSalariais/faixaSalarial.actions';
import { SelectStato } from '../../../../../commons/styleds/selects';
import { useTranslation } from '../../../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/x-date-pickers/locales';

interface Props {
    novoUsuario: boolean;
}

const PPCStepper1: React.FC<Props> = (props: Props) => {
    const { translate, language } = useTranslation();
    const lang = language ?? "pt-br";
    let locale = ptBR;
    switch (lang.slice(0, 2)) {
      case "es":
        locale = esES
        break;
    }
    
    const { novoUsuario } = props;

    const faixaSalarialActions = useFaixaSalarialActions();
    const [faixasSalariais, setFaixasSalariais] = useState<IFaixaSalarial[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const methods = useFormContext();

    useEffect(() => {

        faixaSalarialActions
            .list()
            .then((resp: IFaixaSalarial[]) => {
                setFaixasSalariais(resp);
                setTimeout(() => {
                    setLoading(true);
                }, 1000);
            })
            .catch((err: any) => toast.warn(err));

    }, []);

    return (
        <>
            <Grid container xs={12} md={12} sm={12} sx={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
            }}>
                <Grid xs={12} md={12} sm={12}>
                    <Typography sx={{ padding: "10px 0px" }} variant="h5" component="h2">
                        {translate('informacoesGeraisTitulo')}
                    </Typography>
                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP1'
                        render={({ field: { ref, ...field } }) => (<>
                            <InputLabel sx={{
                                whiteSpace: "normal", fontWeight: "700"
                            }}>
                                {translate('informacoesGeraisP1')}
                            </InputLabel >

                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />
                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP2')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP2'
                        render={({ field: { ref, ...field } }) => (
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        )}
                    />
                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700",
                        marginBottom: "10px"
                    }}>
                        {translate('informacoesGeraisP3')}
                    </InputLabel >
                    {loading &&
                        <Controller
                            control={methods.control}
                            name='idFaixaRemuneracao'
                            disabled
                            render={({ field: { ref, ...field } }) => (
                                <FormControl fullWidth>
                                    <SelectStato {...field} required>
                                        {faixasSalariais.map((statu: IFaixaSalarial, index: number) => (
                                            <MenuItem value={statu.id} key={index}>
                                                <b>{statu.nome}</b>
                                            </MenuItem>
                                        ))}
                                    </SelectStato>
                                </FormControl>
                            )}
                        />
                    }
                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP4')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP3'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP5')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP4'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP6')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP5'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP7')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP6'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP8')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP7'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP9')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP8'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP10')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP9'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP11')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP10'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP12')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP11'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>

                <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "15px", width: "100%", marginTop: "10px" }}>
                    <InputLabel sx={{
                        whiteSpace: "normal", fontWeight: "700"
                    }}>
                        {translate('informacoesGeraisP13')}
                    </InputLabel >
                    <Controller
                        control={methods.control}
                        name='informacaoGeralP12'
                        render={({ field: { ref, ...field } }) => (<>
                            <TextField sx={{ width: "100%" }}
                                id="standard-basic"
                                {...field}
                                inputRef={ref}
                                label=""
                                variant="standard"
                                disabled
                                multiline
                                maxRows={4}
                                inputProps={{ style: { fontWeight: "700" } }}
                            />
                        </>)} />

                </Grid>
            </Grid>
        </>
    );
};

export default PPCStepper1;
